<template>
  <div class="tickets-shell">
    <!-- Lista de atendimentos -->
    <b-container fluid class="tickets-toolbar">
      <b-row>
        <b-col cols="12" lg="6" class="d-flex flex-wrap align-center">
          <v-btn class="ticket-toolbar__btn mr-2 mb-2" color="primary" @click="novoChamado">
            (F2) Novo Recado
            <v-icon right>mdi-plus</v-icon>
          </v-btn>

          <v-btn class="ticket-toolbar__btn mb-2" outlined color="primary" @click="atuChamados">
            (F5) Atualizar Chamados
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </b-col>
        <b-col cols="12" lg="6" class="tickets-toolbar__search">
          <v-text-field placeholder="Filtrar atendimentos" v-model="filtraChamados" outlined clearable dense
            prepend-inner-icon="mdi-magnify" hide-details="auto" class="input-search"></v-text-field>
        </b-col>
      </b-row>
    </b-container>

    <div v-if="lista_chamados_content">
      <div v-if="lista" class="kanban-cards">
        <Kanban :columns.sync="columns" col-min-width="100" col-max-width="700" count-text="Itens"
          drop-text="Solte para mudar o status" @item-dropped="columnChange">
          <template v-slot:card="{ item }">
            <div :class="['item', 'kanban-ticket', 'kanban-ticket__drag', `${item.currentStatus}`]">
              <div class="kanban-ticket__top">
                <div class="kanban-ticket__avatars">
                  <FotoUser
                    :id="item.id_tec_inicial"
                    :tecnicos="tecnicos"
                    :styleImg="{ width: '34px', height: '34px' }"
                  />
                  <FotoUser
                    v-if="item.id_tec_resp != null && item.id_tec_resp != ''"
                    :id="item.id_tec_resp"
                    :tecnicos="tecnicos"
                    :styleImg="{ width: '34px', height: '34px' }"
                  />
                </div>

                <v-menu offset-y left :close-on-content-click="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      class="kanban-ticket__menu"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop
                      @mousedown.stop
                    >
                      <v-icon size="18">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="ticket-actions-list">
                    <v-list-item
                      v-for="(menuItem, index) in items_menu"
                      :key="index"
                      @click.stop="testaMenu(item, menuItem)"
                    >
                      <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <div class="kanban-ticket__body" @click="editChamado(item)">
                <small class="kanban-ticket__date">{{ item.data_hora }}</small>
                <div class="kanban-ticket__title">{{ item.assunto }}</div>
                <div class="kanban-ticket__client">
                  {{ trataNULL(item.nome, "", "") + trataNULL(item.contato, "", " - ") }}
                </div>
              </div>

              <div v-if="item.tags && item.tags !== ''" class="kanban-ticket__tags">
                <v-chip
                  v-for="(t, tdx) in ticketTags(item.tags)"
                  :key="tdx"
                  label
                  x-small
                  class="mr-1 mb-1 ticket-tag ticket-tag--kanban"
                >
                  <span class="ticket-tag__dot"></span>
                  {{ t }}
                </v-chip>
              </div>
            </div>
          </template>
        </Kanban>
      </div>
      <v-card
        v-else
        v-for="_file in files_chamados"
        :key="_file.title"
        class="ticket-card"
        :style="ticketCardStyle(filtro_color)"
      >
        <b-container fluid>
          <b-row class="ticket-card__row align-items-center" no-gutters @dblclick="editChamado(_file)">
            <b-col cols="2" lg="1">
              <b-row>
                <b-col cols="6" class="text-center">
                  <Tag value="Incial" :style="{
                    fontSize: '6.5pt',
                    position: 'absolute',
                    left: '20%',
                    zIndex: '50',
                  }"></Tag>
                  <FotoUser :id="_file.id_tec_inicial" :tecnicos="tecnicos"></FotoUser>
                </b-col>
                <b-col cols="6" class="text-center">
                  <Tag value="Resp" :style="{
                    fontSize: '6.5pt',
                    position: 'absolute',
                    left: '20%',
                    zIndex: '50',
                  }" severity="success"></Tag>

                  <FotoUser :id="_file.id_tec_resp" :tecnicos="tecnicos"></FotoUser>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="5" lg="6" class="ticket-card__main">
              <small class="ticket-card__meta"><strong>{{
                _file.data_hora + trataNULL(_file.tempo, "", " - Tempo: ")
                  }}</strong></small>


              
              <div class="ticket-card__client" v-if="_file.id_cli != '' && _file.id_cli != null">
                <v-icon size="18" color="green" v-if="_file.manutencao">mdi-check-circle-outline</v-icon>
                <v-icon size="18" color="red" v-else-if="!_file.manutencao">mdi-close-circle-outline</v-icon>
                <span>{{ trataNULL(_file.nome, "", "") }}</span>
                <span v-if="_file.contato" class="ticket-card__separator">•</span>
                <span>{{ trataNULL(_file.contato, "", "") }}</span>
              </div>
              <div class="ticket-card__client" v-else-if="_file.contato">
                <span>{{ _file.contato }}</span>
              </div>
              <div class="ticket-card__subject">
                {{ trataNULL(_file.assunto, "Assunto não informado", "") }}
              </div>
            </b-col>
            <b-col cols="4" lg="4" class="ticket-card__side">
              <v-chip v-for="(t, tdx) in ticketTags(_file.tags)" :key="tdx" label x-small class="mr-1 mb-1 ticket-tag">
                <span class="ticket-tag__dot"></span>
                {{ t }}
              </v-chip>
              <div v-if="formatPhones(_file)" class="ticket-card__info-item">
                <v-icon size="16">mdi-phone-outline</v-icon>
                {{ formatPhones(_file) }}
              </div>

              <div v-if="_file.info_any" class="ticket-card__info-item">
                <v-icon size="16">mdi-lan-connect</v-icon>
                {{ _file.info_any }}
              </div>


              <!-- <v-icon small left @click="copiaIDAnyDesk(_file.info_any)">
                mdi-lan-connect
              </v-icon>
              <small>
                {{ trataNULL(_file.info_any, "Anydesk não inf.", " ") }}
              </small>
              <small>
                {{ trataNULL(_file.info_any_senha, "", " - ") }}
              </small> -->

              <v-btn x-small class="ticket-card__action" @click="ViewConexao(_file)">
                <v-icon small left>mdi-lan-connect</v-icon>
                Inf. de conexão </v-btn>
              <!-- <v-btn x-small dark color="green darken-4" @click="ViewRetorno(_file)">
                <v-icon small>mdi-chat-processing-outline</v-icon>&nbsp;
                Retornar
              </v-btn> -->
              <!-- <v-icon size="small" color="success" @click="copyAnydesk()"
              >_file_copy</v-icon
            > -->
            </b-col>

            <b-col cols="1" lg="1" class="text-end ticket-card__menu-col">
              <v-menu top :close-on-click="true" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ticket-card__menu" @click.stop>
                    <v-icon color="#475569">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense class="ticket-actions-list">
                  <v-list-item v-for="(item, index) in items_menu" :key="index" @click.stop="testaMenu(_file, item)">
                    <v-list-item-title>{{
                      item.title
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </b-col>
          </b-row>
        </b-container>
      </v-card>
    </div>
    <v-dialog v-model="modal_conexao" max-width="1200" scrollable transition="dialog-top-transition">
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10">Informações de conexão </b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_conexao = false" text icon x-large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text style="max-height: 900px">
          <b-container fluid>
            <b-row :style="{ paddingTop: '10px' }">
              <b-col cols="6">
                <v-text-field label="ID AnyDesk" placeholder="Não informado" outlined v-model="file_conexao.info_any"
                  hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="6">
                <v-text-field label="Senha AnyDesk" placeholder="Não informado" outlined
                  v-model="file_conexao.info_any_senha" hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <v-text-field label="IP Externo" placeholder="Não informado" outlined
                  v-model="file_conexao.info_ip_externo" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="6">
                <v-text-field label="IP Interno" placeholder="Não informado" outlined
                  v-model="file_conexao.info_ip_acesso" hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <!-- <Editor v-model="file_conexao.info" editorStyle="height: 300px">
                </Editor> -->
                <vue-editor v-model="file_conexao.info" id="editorChamado"></vue-editor>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="salvarInformacoesCli" color="grey darken-4" dark block>
            <v-icon>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_retorno" max-width="1200" scrollable transition="dialog-top-transition"
      :hide-overlay="true">
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="12" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="fecharRetorno" text icon x-large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>

        <v-card-text>
          <b-container fluid>
            <div class="return-thread">
              <div class="return-thread__day">Mensagem original</div>
              <div class="return-thread__bubble return-thread__bubble--initial">
                <div class="return-thread__meta">
                  <strong v-if="file.nome != null && file.nome != ''">
                    {{
                      trataNULL(file.nome, "", "") +
                      trataNULL(file.contato, "", " - ")
                    }}
                  </strong>
                  <strong v-else>{{ trataNULL(file.assunto, "", "") }}</strong>
                  <span>{{ file.data_hora || (file.datac + " - " + file.horac) }}</span>
                </div>
                <div class="return-thread__subject">
                  {{ trataNULL(file.assunto, "Assunto nao informado", "") }}
                </div>
                <div class="return-thread__content" v-html="mensagemObsRenderizada"></div>
              </div>
            </div>
            <b-row>
              <b-col cols="12" :style="{ paddingBottom: '0px' }">
                <ChamadoResolucoes :id="id_chamado_resolucoes" :tecnicos="tecnicos" :limpa="limpa_resolucoes"
                  @getResolucoes="getResolucoes"></ChamadoResolucoes>
              </b-col>
            </b-row>
            <div class="return-thread__footer">
              <v-checkbox
                v-model="resolvido"
                label="Finalizar atendimento"
                color="grey darken-4"
                hide-details="auto"
                small
              ></v-checkbox>
            </div>
          </b-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="updateFinalizar" color="grey darken-4" dark block>
            <v-icon>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_novo" :fullscreen="true" scrollable transition="dialog-top-transition"
      :hide-overlay="true">
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10" class="text-center">
              <b-row :style="{ fontSize: '10pt !important', paddingLeft: '50px' }">
                <b-col>
                  <b-row>
                    <FotoUser :id="file.id_tec_inicial" :tecnicos="tecnicos"></FotoUser>
                    <div :style="{ paddingLeft: '30px', lineHeight: '1' }">
                      <br />

                      <small>Data do atendimento</small><br />
                      <strong>{{ file.datac + " - " + file.horac }}</strong>
                    </div>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_novo = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>

        <v-card-text>
          <b-container fluid>
            <TabView :activeIndex.sync="activeTabAtendimento" color="grey">
              <TabPanel header="Atendimento Inicial">
                <b-container fluid>
                  <b-row :style="{ padding: '0px' }">
                    <b-col cols="6">
                      <AutoBusca id="cliente" item_id="id" item_text="nome"
                        item_campos="cli.id as id, cli.id|| ' - ' || TRIM(cli.nome) || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome, cli.cnpj"
                        item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
                        item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid" tabela="cliente cli"
                        :value="file.id_cli" @getID="getID" :label="'Digite o cliente'" condicao="cli.id > 10000" />




                      <v-chip v-for="(t, tdx) in dtStatus" :key="tdx" outlined pill small>
                        <v-avatar class="accent white--text" left v-text="t.slice(0, 1).toUpperCase()"></v-avatar>
                        {{ t }}
                      </v-chip>
                    </b-col>
                    <b-col cols="3">
                      <v-select v-model="file.tipo" :items="Enum.situacao" outlined label="Tipo do chamado"
                        hide-details="auto" item-text="text" item-value="val"
                        no-data-text="Nenhuma Informação disponível"></v-select>
                    </b-col>
                    <b-col cols="3">
                      <AutoBuscaDrop id="tecnico" item_id="id" item_text="nome" item_pk="id"
                        item_campos="tec.id as id, tec.nome as nome"
                        item_busca="tec.id::char|| '-' || TRIM(UPPER(tec.nome)) " item_left="" item_ordem="nome"
                        item_condicao="coalesce(ativo,true)=true" tabela="tecnico tec" :value="file.id_tec_resp"
                        @getID="getID" :label="'Digite o tecnico responsável'" />

                    </b-col>


                  </b-row>

                  <b-row :style="{ padding: '0px' }">
                    <b-col cols="5">
                      <v-combobox v-model="file.tags" :items="items" label="Tags" multiple outlined :hide-details="true"
                        :hide-no-data="true" :return-object="false">
                        <template v-slot:selection="data">
                          <v-chip :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected"
                            :disabled="data.disabled" @click:close="data.parent.selectItem(data.item)">
                            <v-avatar class="accent white--text" left
                              v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </b-col>
                    <b-col cols="3">
                      <v-text-field label="Data de previsão" placeholder="" outlined hide-details="auto"
                        v-model="file.data_pre" type="date"></v-text-field>
                    </b-col>
                    <b-col cols="2">
                      <v-text-field label="Tempo de duração" placeholder="" outlined hide-details="auto"
                        v-model="file.tempo" type="time"></v-text-field>
                    </b-col>
                    <b-col cols="2">
                      <v-checkbox v-model="file.resolvido" label="FINALIZAR" color="grey darken-4"></v-checkbox>
                    </b-col>
                  </b-row>
                  <b-row :style="{ padding: '0px' }">
                    <b-col>
                      <v-text-field label="Assunto" placeholder="Informar assunto" outlined v-model="file.assunto"
                        hide-details="auto" sync></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row :style="{ padding: '0px' }">
                    <b-col cols="4">
                      <v-text-field label="Contato" placeholder="Não informado" outlined v-model="file.contato"
                        hide-details="auto"></v-text-field>
                    </b-col>
                    <b-col cols="4">
                      <v-text-field label="Fone" placeholder="Não informado" outlined v-model="file.fone"
                        hide-details="auto" v-mask="['(##) ####-####', '(##) #####-####']"></v-text-field>
                    </b-col>
                    <b-col cols="4">
                      <v-text-field label="Fone 2" placeholder="Não informado" outlined v-model="file.fone2"
                        hide-details="auto" v-mask="['(##) ####-####', '(##) #####-####']"></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row v-if="false">
                    <b-col cols="12">
                      <v-text-field label="Email" placeholder="Não informado" outlined v-model="file.email"
                        hide-details="auto"></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row :style="{ padding: '0px' }">
                    <b-col cols="12">
                      <!-- <Editor v-model="file.mensagem" editorStyle="height: 250px">
                      </Editor> -->
                      <div class="editor-shell editor-shell--description">
                        <vue-editor v-model="file.mensagem" id="editorChamado2"></vue-editor>
                      </div>
                      <!-- :readonly="disable_recado" -->
                    </b-col>

                  </b-row>
                  <b-row :style="{ padding: '0px' }">
                    <b-col cols="12">

                      <ChamadoResolucoes :id="id_chamado_resolucoes" :tecnicos="tecnicos" :limpa="limpa_resolucoes"
                        @getResolucoes="getResolucoes" :altura="41"></ChamadoResolucoes>

                    </b-col>
                  </b-row>
                  <!--  <b-row :style="{padding:'0px'}">

                    <b-col>
                      <v-checkbox v-model="file.aviso_retorno" label="Avisar novos retornos"
                        color="grey darken-4"></v-checkbox>
                    </b-col>
                  </b-row> -->
                </b-container>
              </TabPanel>

              <TabPanel v-if="file.id_cli != null && file.id_cli != ''" header="Inf. Conexão">
                <b-container fluid>
                  <b-row>
                    <b-col cols="6">
                      <v-text-field label="ID AnyDesk" placeholder="Não informado" outlined v-model="file.info_any"
                        hide-details="auto"></v-text-field>
                    </b-col>
                    <b-col cols="6">
                      <v-text-field label="Senha AnyDesk" placeholder="Não informado" outlined
                        v-model="file.info_any_senha" hide-details="auto"></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <v-text-field label="IP Externo" placeholder="Não informado" outlined
                        v-model="file.info_ip_externo" hide-details="auto"></v-text-field>
                    </b-col>
                    <b-col cols="6">
                      <v-text-field label="IP Interno" placeholder="Não informado" outlined
                        v-model="file.info_ip_acesso" hide-details="auto"></v-text-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <!--     <Editor v-model="file.info" editorStyle="height: 300px">
                      </Editor> -->

                      <vue-editor v-model="file.info" id="editorChamado"></vue-editor>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <v-btn @click="salvarInformacoesCli2" text x-large>
                        <v-icon>mdi-content-save</v-icon>Salvar observações
                      </v-btn>
                    </b-col>
                  </b-row>
                </b-container>
              </TabPanel>
              <!--               <TabPanel v-if="file.id_cli != null && file.id_cli != ''" header="Mapa de rede">
                <b-container fluid>
                 
                </b-container>
              </TabPanel> -->
              <TabPanel v-if="file.id_cli != null && file.id_cli != ''" header="Versões/Terminais reg.">
                <b-container fluid>
                  <div>
                    <b-row>
                      <b-col cols="2">Modulo</b-col>
                      <b-col cols="2">TTY</b-col>
                      <b-col cols="2">Data Acesso</b-col>
                      <b-col cols="2">Versão</b-col>
                    </b-row>
                  </div>
                  <v-divider></v-divider>
                  <div v-for="(i, idx) in dtVersoes" :key="idx">
                    <b-row>
                      <b-col cols="2">{{ i.modulo }}</b-col>
                      <b-col cols="2">{{ i.tty }}</b-col>
                      <b-col cols="2">{{ i.datac }}</b-col>
                      <b-col cols="2">{{ i.puversao }}</b-col>
                    </b-row>
                  </div>
                </b-container>
              </TabPanel>
              <TabPanel v-if="file.id_cli != null && file.id_cli != ''" header="Faturamento">
                <b-container fluid>

                  <v-btn @click="ultimoBoletoGerado" v-if="file.id_cli != null && file.id_cli != ''" size="small" block
                    color="green darken-2" dark>
                    <v-icon>mdi-download</v-icon>Acessar último boleto gerado
                  </v-btn>
                  <!--  <b-row>
                    <b-col>
                      <ChamadoResolucoes :id="id_chamado_resolucoes" :tecnicos="tecnicos" :limpa="limpa_resolucoes"
                        @getResolucoes="getResolucoes" :altura="60"></ChamadoResolucoes>
                    </b-col>
                  </b-row> -->
                </b-container>
              </TabPanel>
            </TabView>
          </b-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="salvarContato" block color="grey darken-4" dark>
            <v-icon>mdi-content-save</v-icon>(F10) - Salvar atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ExecutaSQL from "../domain/ExecutaSQL.js";
import Chamado from "../domain/Chamado.js";
import GenCli from "../domain/Gencli";
import MeuBoleto from "../domain/MeuBoleto";
import AutoBusca from "../components/AutoBusca.vue";
import AutoBuscaDrop from "../components/AutoBuscaDrop.vue";
import FotoUser from "../components/FotoUser.vue";
import ChamadoResolucoes from "../components/ChamadoResolucoes.vue";
import _Enum from "../obj/Enum";
import Editor from "primevue/editor";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Tag from "primevue/tag";
import { saveAs } from "@progress/kendo-file-saver";
import { VueEditor } from "vue2-editor";
import { applyDrag, scene } from "../Utils/helpers";
import Kanban from "../components/Kanban.vue";


export default {
  name: "CardsKanban",
  components: {
    AutoBusca,
    FotoUser,
    ChamadoResolucoes,
    Editor,
    TabView,
    TabPanel,
    Tag,
    AutoBuscaDrop,
    VueEditor,
    Kanban
  },
  props: ["files", "filtro_color", "tecnicos", "lista", "tipoc"],
  data: () => ({
    Enum: _Enum,
    file: {},
    file_conexao: {},
    data: [],
    zIndex: 0,
    items_menu: [
      { id: "edit", title: "Abrir chamado" },
      { id: "finish", title: "Finalizar atendimento" },
      { id: "delete", title: "Excluir" },
    ],
    sheet_contatos: false,
    filtraChamados: "",
    modal_contatos: false,
    tab_contato: 0,
    modal_novo: false,
    oper: "",
    item_campos_cliente: "",
    id_chamado_resolucoes: "",
    limpa_resolucoes: false,
    disable_recado: false,
    observacao: "",
    modal_view: false,
    modal_conexao: false,
    modal_retorno: false,
    msg_recado: "",
    mensagem_obs: "",
    items: [
      "SagewPG",
      "Postgres",
      "REDE",
      "SageWeb",
      "SageAPP",
      "Boletos",
      "Novo Desenvolvimento",
      "Alteração",
      "Financeiro",
      "Atualização",
      "TEF",
      "SEFAZ",
      "Pessoal da Programação",
      "Manutenção",
      "Sugestão",
      "Dica",
      "Tributário",
      "Contabilidade",
      "Backup",
      "Caixa",
      "Banco de Dados",
      "Nuvem",
    ],
    items_assunto: [
      "Entrar em contato",
      "Erro no Caixa",
      "Importação XML de Nota de compra",
      "SPED Fiscal",
      "Formatou Máquina",
      "Falar com Daniel",
      "Agendar treinamento",
      "Atualização do SAGE",
      "Atualização do Caixa",
      "Não acessa BANCO DE DADOS",
      "SageApp ",
      "Boletos CobreFacil",
      "LEIAME ",
      "Erro no SAGE",
      "Certificado digital",
      "Ganhe Pontos",
    ],
    dtStatus: [],
    dtVersoes: [],
    activeTabAtendimento: 0,
    lista_chamados_content: true,
    id_cli: "",
    info_any: "",
    info_any_senha: "",
    tipo: "",
    tags: [],
    id_tec_resp: "",
    data_pre: "",
    tempo: "",
    resolvido: false,
    assunto: "",
    contato: "",
    fone: "",
    fone2: "",
    email: "",
    mensagem: "",
    item: {},
    columns: [
      {
        name: "Na Fila",
        id: 0,
        status: ["open", "fila"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(src, payload, index, (origins = ["review", "test", "closed"])), */
      },
      {
        name: "Executando",
        id: 1,
        status: ["executing", "review", "paralised"],
        columnItems: [],
        /* validation: (src, payload, index, origins) =>
          this.columnValidation(
            src,
            payload,
            index,
            (origins = ["open", "paralised"])
          ), */
      },
      {
        name: "Testando",
        id: 2,
        status: ["testando", "test"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(
             src,
             payload,
             index,
             (origins = ["executing", "review"])
           ), */
      },
      {
        name: "Finalizado",
        id: 3,
        status: ["finished", "closed"],
        columnItems: [],
        /*  validation: (src, payload, index, origins) =>
           this.columnValidation(
             src,
             payload,
             index,
             (origins = ["test", "closed","open"])
           ), */
      },
    ],
    showDropdown: {},
    opcoesDropdownMenu: [
      { type: "customAction" },
      { type: "separator", color: "yellow" },
      { type: "customAction" },
    ],
    scene,
    upperDropPlaceholderOptions: {
      className: "cards-drop-preview",
      animationDuration: "150",
      showOnTop: true,
    },
    dropPlaceholderOptions: {
      className: "drop-preview",
      animationDuration: "150",
      showOnTop: true,
    },
  }),

  watch: {
    modal_novo: function (val) {
      this.lista_chamados_content = !val;
      if (!val) this.id_chamado_resolucoes = null;
    },
    modal_retorno: function (val) {
      if (!val) {
        this.mensagem_obs = "";
      }
    },

    files: function (val) {
      this.data = val;


      this.carregaDrop();
    },

    filtraChamados:function(val){
      let valores = this.data;
      var wbusca = "";
      if (this.filtraChamados != null)
        wbusca = this.filtraChamados.toString().toLowerCase();

      if (wbusca != "") {
        var wvalores = valores.filter((item) => {
          if (item.nome == null) item.nome = "";
          if (item.assunto == null) item.assunto = "";
          return item.assunto.toLowerCase().indexOf(wbusca) > -1 ||
            item.nome.toLowerCase().indexOf(wbusca) > -1 ||
            JSON.stringify(item.tags).toLowerCase().indexOf(wbusca) > -1
            ? item
            : null;
        });
        valores = wvalores;
      } else {
        valores = this.data;
      }
      

      this.carregaDrop(wvalores);

      //return valores;
    }

  },

  created() {
    window.addEventListener("keydown", this.onkey);
    if (typeof this.tipoc != "undefined") this.tipo = this.tipoc;
    this.data = this.files;
  },

  mounted() {

    if (this.data.length > 0) {
      this.carregaDrop();
    }
  },

  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    mensagemObsRenderizada() {
      return this.decodeHtmlField(this.mensagem_obs || this.file.mensagem || "");
    },

    files_chamados() {
      let valores = this.data;
      var wbusca = "";
      if (this.filtraChamados != null)
        wbusca = this.filtraChamados.toString().toLowerCase();

      if (wbusca != "") {
        var wvalores = valores.filter((item) => {
          if (item.nome == null) item.nome = "";
          if (item.assunto == null) item.assunto = "";
          return item.assunto.toLowerCase().indexOf(wbusca) > -1 ||
            item.nome.toLowerCase().indexOf(wbusca) > -1 ||
            JSON.stringify(item.tags).toLowerCase().indexOf(wbusca) > -1
            ? item
            : null;
        });
        valores = wvalores;
      } else {
        valores = this.data;
      }

      return valores;
    },

    notMobile() {
      return window.innerWidth >= 1025;
    },
  },

  methods: {
    onkey(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }

      // F2 novo
      if (e.keyCode == 113 && this.multi !== "") {
        this.novoChamado();
        e.returnValue = false;
        return;
      }

      // F5 refresh
      if (e.keyCode == 116) {
        this.atuChamados();
        e.returnValue = false;
        return;
      }

      // F10
      if (e.keyCode == 121) {
        if (this.modal_novo == true) {
          this.salvarContato();
        }
        //$(".input-search").focus();
        e.returnValue = false;
        return;
      }
    },
    carregaDrop(data) {

      if(data == null) data = this.data;
      if (this.lista) {
        console.log(this.data);
        this.columns[0].columnItems = [];
        this.columns[1].columnItems = [];
        this.columns[2].columnItems = [];
        this.columns[3].columnItems = [];
        for (var i = 0; i < data.length; i++) {

          var id_coluna = 0;
          var status_prev = [];
          if (data[i].status == "open") {
            id_coluna = 0;
            status_prev = ["review", "test", "closed"]
          }
          if (data[i].status == "executing") {
            id_coluna = 1;
            status_prev = ["open", "paralised"]
          }
          if (data[i].status == "testando") {
            id_coluna = 2;
            status_prev = ["executing", "review"]
          }
          if (data[i].status == "finished") {
            id_coluna = 3;
            status_prev = ["test", "closed"]
          }

          console.log(data[i].status)
          this.cardsKanban(id_coluna, data[i], data[i].status, status_prev, i);

        }
      }
    },
    resolveAccent(color) {
      switch (color) {
        case "yellow lighten-4":
          return "#fff59d";
        case "red lighten-4":
          return "#ffcdd2";
        case "green lighten-4":
          return "#c8e6c9";
        case "orange lighten-4":
          return "#ffe0b2";
        case "purple lighten-4":
          return "#e1bee7";
        case "blue lighten-4":
          return "#bbdefb";
        case "indigo lighten-4":
          return "#c5cae9";
        case "grey lighten-1":
          return "#b0bec5";
        default:
          return "#b2dfdb";
      }
    },
    resolveAccentStrong(color) {
      switch (color) {
        case "yellow lighten-4":
          return "#b45309";
        case "red lighten-4":
          return "#b91c1c";
        case "green lighten-4":
          return "#15803d";
        case "orange lighten-4":
          return "#c2410c";
        case "purple lighten-4":
          return "#7e22ce";
        case "blue lighten-4":
          return "#1d4ed8";
        case "indigo lighten-4":
          return "#4338ca";
        case "grey lighten-1":
          return "#475569";
        default:
          return "#0f766e";
      }
    },
    resolveAccentSoft(color) {
      switch (color) {
        case "yellow lighten-4":
          return "rgba(255, 245, 157, 0.28)";
        case "red lighten-4":
          return "rgba(255, 205, 210, 0.32)";
        case "green lighten-4":
          return "rgba(200, 230, 201, 0.32)";
        case "orange lighten-4":
          return "rgba(255, 224, 178, 0.32)";
        case "purple lighten-4":
          return "rgba(225, 190, 231, 0.32)";
        case "blue lighten-4":
          return "rgba(187, 222, 251, 0.32)";
        case "indigo lighten-4":
          return "rgba(197, 202, 233, 0.32)";
        case "grey lighten-1":
          return "rgba(176, 190, 197, 0.28)";
        default:
          return "rgba(178, 223, 219, 0.28)";
      }
    },
    ticketCardStyle(color) {
      return {
        "--ticket-accent": this.resolveAccent(color),
        "--ticket-accent-strong": this.resolveAccentStrong(color),
        "--ticket-accent-soft": this.resolveAccentSoft(color),
      };
    },
    ticketTags(tags) {
      if (tags == null || tags === "") return [];
      if (Array.isArray(tags)) return tags;

      try {
        return JSON.parse(tags);
      } catch (err) {
        return [];
      }
    },
    formatPhones(file) {
      const values = [file.fone, file.fone2].filter(
        (value) => value != null && value !== ""
      );
      return values.join("  |  ");
    },
    decodeMaybeBase64(value) {
      if (value == null || value === "") return "";
      if (typeof value !== "string") return value;

      const trimmed = value.trim();
      const normalized = trimmed.replace(/\s+/g, "");
      const looksLikeBase64 =
        normalized.length >= 8 &&
        /^[A-Za-z0-9+/=]+$/.test(normalized);

      if (!looksLikeBase64) return value;

      try {
        const padding = (4 - (normalized.length % 4 || 4)) % 4;
        const padded = normalized + "=".repeat(padding);
        const decoded = Vue.atob(padded);
        if (/[\x00-\x08\x0E-\x1F]/.test(decoded)) return value;
        return decoded || value;
      } catch (err) {
        return value;
      }
    },
    decodeHtmlField(value) {
      const decoded = this.decodeMaybeBase64(value);
      return Vue.replaceAll(decoded, "\n", "<br>");
    },

    trataNULL(valor, padrao, prefix) {
      if (valor == null || valor == "") return padrao;
      return prefix + valor;
    },

    testaMenu(chamado, menu) {
      if (menu.id == "edit") {
        this.editChamado(chamado);
      }

      if (menu.id == "finish") {
        this.ViewRetorno(chamado);
      }

      if (menu.id == "delete") {
        this.excluirChamado(chamado);
      }
    },

    verContato() {
      this.sheet_contatos = true;
    },

    getID(val) {

      if (val.id == "cliente") {
        console.log(val.value);
        this.dtStatus = [];
        //if (this.file.id_cli != val.value) {
        this.file.id_cli = val.value;
        this.getInformacoesCli(1);

        //}
      }

      if (val.id == "tecnico") this.file.id_tec_resp = val.value;
    },

    getInformacoesCli(opt) {
      var wsql =
        " SELECT " +
        "   cli.cnpj, cli.fone, cli.fone2, cli.email, cli.regras, cli.anydesk_id as info_any, " +
        "   cli.anydesk_senha as info_any_senha, cli.ip_acesso as info_ip_externo, " +
        "   cli.ipinterno_acesso as info_ip_acesso, " +
        "   replace(replace(cli.obs_acesso,Chr(10),'<br>'),Chr(13),'<br>') as info " +
        " FROM cliente cli " +
        " WHERE id= " +
        this.file.id_cli;
      var vm = this;
      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (tmp) {
          if (tmp.length > 0) {
            vm.file.cnpj = tmp[0].cnpj;
            vm.verificaBloqueiosVersoes();
            if (opt == 1) {
              vm.file.fone = tmp[0].fone;
              vm.file.fone2 = tmp[0].fone2;
              vm.file.email = tmp[0].email;
              vm.file.regras = tmp[0].regras;
              vm.file.info_any_senha = tmp[0].info_any_senha;
              vm.file.info_any = tmp[0].info_any;
              vm.file.info_ip_externo = tmp[0].info_ip_externo;
              vm.file.info_ip_acesso = tmp[0].info_ip_acesso;
              vm.file.info = vm.decodeHtmlField(tmp[0].info);
              //vm.file.info = Vue.replaceAll(vm.file.info, "\n", "<br>");
            } else if (opt == 2) {
              vm.file_conexao.regras = tmp[0].regras;
              vm.file_conexao.info_any_senha = tmp[0].info_any_senha;
              vm.file_conexao.info_any = tmp[0].info_any;
              vm.file_conexao.info_ip_externo = tmp[0].info_ip_externo;
              vm.file_conexao.info_ip_acesso = tmp[0].info_ip_acesso;
              vm.file_conexao.info = vm.decodeHtmlField(tmp[0].info);
              /* vm.file_conexao.info = Vue.replaceAll(
                vm.file_conexao.info,
              Chr(10)  "\n",
                "<br>"
              ); */
              vm.modal_conexao = true;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    editChamado(file) {
      this.oper = "U";
      this.activeTabAtendimento = 0;
      this.file = JSON.parse(JSON.stringify(file));
      this.getInformacoesCli(1);
      this.verificaBloqueiosVersoes();

      this.file.data_pre = Vue.fData2(this.file.data_pre);
      this.file.mensagem = this.decodeHtmlField(this.file.mensagem);
      //this.file.mensagem = this.file.mensagem;

      this.file.info = this.decodeHtmlField(this.file.info);

      if (file.tags != null && file.tags != "")
        this.file.tags = JSON.parse(file.tags);

      this.id_chamado_resolucoes = this.file.id;

      if (
        this.getUser.id == this.file.id_tec_inicial ||
        this.getUser.id == this.file.id_tec_resp
      )
        this.disable_recado = false;
      else this.disable_recado = true;

      this.dtStatus = [];
      this.modal_novo = true;
    },

    salvarInformacoesCli() {
      var _file = JSON.parse(JSON.stringify(this.file_conexao));
      _file.info = Vue.btoa(_file.info);

      var dados = [
        {
          file: [_file],
        },
      ];

      Vue.Loading("Gravando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.upCliente(dados).then(
        function () {
          this.modal_conexao = false;
          this.file = {};
          this.file_conexao = {};
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    salvarInformacoesCli2() {
      var _file = {
        id_cli: this.file.id_cli,
        regras: this.file.regras,
        info_any_senha: this.file.info_any_senha,
        info_any: this.file.info_any,
        info_ip_externo: this.file.info_ip_externo,
        info_ip_acesso: this.file.info_ip_acesso,
        info: Vue.atob(this.file.info),
      };

      var dados = [
        {
          file: [_file],
        },
      ];

      Vue.Loading("Gravando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.upCliente(dados).then(
        function () {
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    contato(file) {
      this.file_conexao = JSON.parse(JSON.stringify(file));
      this.modal_novo = true;
    },

    ViewConexao(file) {
      this.file = file;
      this.file_conexao = JSON.parse(JSON.stringify(file));
      this.getInformacoesCli(2);
    },

    ViewRetorno(file) {
      this.file = JSON.parse(JSON.stringify(file));
      this.id_chamado_resolucoes = this.file.id;
      this.file.mensagem = this.decodeHtmlField(this.file.mensagem);
      this.mensagem_obs = this.file.mensagem;
      this.modal_retorno = true;
      this.resolvido = this.file.resolvido;
    },
    fecharRetorno() {
      this.modal_retorno = false;
      this.mensagem_obs = "";
    },

    salvarContato() {
      this.salvarChamado();
    },

    novoChamado() {
      //this.$router.replace({ name: "novochamado" });

      this.oper = "I";
      this.file = {
        id: "",
        id_cli: null,
        datac: Vue.getData(),
        horac: Vue.getHora(),
        fone: "",
        fone2: "",
        email: "",
        regras: "",
        tipo: "",
        contato: "",
        mensagem: "",
        nome: "",
        cnpj: "",
        resolvido: false,
        assunto: "",
        data_pre: Vue.fData2(Vue.getData()),
        data_resolvido: "",
        hora_resolvido: "",
        id_tec_inicial: this.getUser.id,
        id_tec_resp: 0,
        info_any: "",
        info_any_senha: "",
        info_ip_externo: "",
        info_ip_acesso: "",
        info: "",
        tags: "",
        tempo: "",
        aviso_retorno: false
      };

      this.activeTabAtendimento = 0;
      this.file.tipo = this.tipoc || "1";
      this.id_chamado_resolucoes = null;
      this.limpa_resolucoes = !this.limpa_resolucoes;
      this.resolucoes = [];
      this.disable_recado = false;
      this.dtStatus = [];
      this.dtVersoes = [];

      this.modal_novo = true;
    },

    atuChamados() {
      this.$emit("confirmouChamado");
    },

    getResolucoes(val) {
      this.resolucoes = val.resolucoes;
    },

    salvarChamado() {
      /* if (this.file.assunto == "") {
        this.file.assunto = "";
      } */

      if (this.file.tipo == "" || this.file.tipo == null) this.file.tipo = "1";
      var _file = JSON.parse(JSON.stringify(this.file));
      _file.mensagem = Vue.btoa(_file.mensagem);
      _file.info = Vue.btoa(_file.info);

      var dados = [
        {
          file: [_file],
          res: this.resolucoes,
        },
      ];

      Vue.Loading("Processando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.save(dados).then(
        function () {
          this.modal_novo = false;
          this.file = {};
          this.file_conexao = {};
          Vue.CloseLoading(this);
          this.$emit("confirmouChamado");
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    excluirChamado(i) {
      // Pergunta se deseja realmente excluir

      //vm, title, content, callSim, callNao
      var vm = this;
      Vue.Pergunta(
        vm,
        "Excluir",
        "Deseja realmente excluir o chamado ?",

        function () {
          vm.service = new Chamado(vm.$resource);
          vm.service.delChamado(i.id, vm.getUser.id).then(
            function () {
              vm.$emit("confirmouChamado");
            },
            () => { }
          );
        },

        null
      );
    },

    TempoEspera() {
      return "";

      /* if (
        data1 == null ||
        hora1 == null ||
        data2 == null ||
        hora2 == null ||
        data1 == "" ||
        hora1 == "" ||
        data2 == "" ||
        hora2 == ""
      )
        return "";

      var data1_ajustada = Vue.getDataInput(data1);
      var day1 = new Date(data1_ajustada + "T" + hora1 + ":00");
      var data2_ajustada = Vue.getDataInput(data2);
      var day2 = new Date(data2_ajustada + "T" + hora2 + ":10");
      var difference = new Date(day2 - day1);

      var resultado = "";
      resultado += difference.getUTCHours() + " Horas e ";
      resultado += difference.getUTCMinutes() + " Minutos";

      return "Tempo para finalização: " + resultado; */
    },

    updateFinalizar() {
      var vm = this;
      var wsql =
        "UPDATE chamado SET resolvido = " +
        (vm.resolvido ? "True" : "False") +
        " WHERE id=" +
        vm.file.id;

      vm.service = new ExecutaSQL(vm.$resource);
      vm.service.get(wsql).then(
        function () {
          vm.$emit("confirmouChamado");
          vm.fecharRetorno();
        },
        (err) => {
          console.log(err);
        }
      );

      /* Vue.Pergunta(
        vm,
        "Atendimento",
        "Deseja confirmar operação",
        function () {
          
        },
        function () {}
      ); */
    },

    copiaIDAnyDesk(texto) {
      if (texto == null || texto == "") {
        Vue.Mensagem(this, "ID AnyDesk", "ID AnyDesk não informado");
        return;
      }

      let text = texto;
      navigator.clipboard.writeText(text);
      Vue.Mensagem(this, "ID AnyDesk", "Copiado com sucesso!");
    },

    verificaBloqueiosVersoes() {
      this.service = new GenCli(this.$resource);
      this.service.getStatus(this.file.cnpj).then(
        function (ret) {
          this.dtVersoes = JSON.parse(ret.genCli);
          var wstatus = JSON.parse(ret.statusSigad);
          if (wstatus != null) {
            this.dtStatus = [];
            var wdtStatus = wstatus.split("|")[2];
            var wdtStatus2 = wdtStatus.split(";");
            for (var i = 0; i < wdtStatus2.length; i++) {

              if (wdtStatus2[i] != '')
                this.dtStatus.push(wdtStatus2[i]);
            }

          } else {
            this.dtStatus = [];
          }
        },
        () => { }
      );
    },

    ultimoBoletoGerado() {
      Vue.Loading("", "", this);
      this.service = new MeuBoleto(this.$resource);
      this.service.get(this.file.cnpj).then(
        function (tmp) {

          var wDown = tmp.BoletoPDF;
          var wNome = this.file.cnpj + ".pdf";
          const dataURI = "data:text/plain;base64," + wDown;
          saveAs(dataURI, wNome);

          Vue.CloseLoading(this);

          // data:image/pdf;base64,

        },
        () => { }
      );
    },

    iconType(status) {
      switch (status) {
        case "finished":
          return "🚀";
        case "executing":
          return "🤔";
        case "testando":
          return "😰";
        default:
          return "😴";
      }
    },

    cardsKanban(colunaId, items, currentStatus, statusList, index) {
      console.log(statusList);
      const current = this.columns.find((item) => item.id === colunaId);
      //const random = Math.floor(Math.random() * 99);

      items.icon = this.iconType(currentStatus);
      items.corStatus = {
        nome: currentStatus,
        corTexto: `#2${index}1ba8`,
        cor: `#2${index}3ced`,
      };
      items.dropdownId = items.id;
      items.currentStatus = currentStatus;
      current.columnItems.push(items);

      /*  current.columnItems.push({
         id: items.id,
         assunto: items.assunto,
         data_hora: items.data_hora,
         status: statusList,
         currentStatus,
         icon: this.iconType(currentStatus),
         dropdownId: items.id,
         tags: JSON.parse(items.tags),
         corStatus: {
           nome: currentStatus,
           corTexto: `#2${index}1ba8`,
           cor: `#2${index}3ced`,
         },
         id_tec_inicial: items.id_tec_inicial,
         id_tec_resp: items.id_tec_resp
       }); */


    },

    selectStatus(item) {
      this.showDropdown = {
        id: item.id,
      };
    },
    columnChange({ item, column }) {
      const targetStatus = Array.isArray(column) ? column[0] : column;
      if (!targetStatus || item.currentStatus === targetStatus) return;

      item.currentStatus = targetStatus;
      item.status = targetStatus;
      item.icon = this.iconType(targetStatus);

      this.alteraStatusBanco(item.id, targetStatus);
    },
    alteraStatusBanco(id, status) {


      var wsql = `UPDATE chamado SET status='${status}' WHERE id=${id}`;
      console.log(wsql);
      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function () {
          this.atuChamados();
        }, () => { });
    },

    columnValidation(src, payload, index, possibleOrigins) {
      return possibleOrigins.includes(payload.currentStatus);
    },

    onColumnDrop(dropResult) {
      const scene = Object.assign({}, this.scene);
      scene.children = applyDrag(scene.children, dropResult);
      this.scene = scene;
    },

    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const scene = Object.assign({}, this.scene);
        const column = scene.children.filter((p) => p.id === columnId)[0];
        const columnIndex = scene.children.indexOf(column);

        const newColumn = Object.assign({}, column);
        newColumn.children = applyDrag(newColumn.children, dropResult);
        scene.children.splice(columnIndex, 1, newColumn);

        this.scene = scene;
      }
    },

    getCardPayload(columnId) {
      return (index) => {
        return this.scene.children.filter((p) => p.id === columnId)[0].children[
          index
        ];
      };
    },

    dragStart() {
      console.log("drag started");
    },

    log(...params) {
      console.log(...params);
    },
  },
};
</script>
<style>
#editorChamado {
  height: auto;
}

#editorChamado2 {
  height: auto;
}

#editorChamado .ql-container,
#editorChamado2 .ql-container {
  height: auto !important;
}

#editorChamado .ql-editor {
  min-height: 96px;
  max-height: 320px;
  overflow-y: auto;
}

#editorChamado2 .ql-editor {
  min-height: 120px;
  max-height: 360px;
  overflow-y: auto;
}

.editor-shell--description {
  margin-top: 8px;
}

.editor-shell--description .ql-toolbar.ql-snow {
  border: 1px solid rgba(148, 163, 184, 0.22) !important;
  border-bottom: 0 !important;
  border-radius: 18px 18px 0 0;
  background: rgba(255, 255, 255, 0.98);
}

.editor-shell--description .ql-container.ql-snow {
  border: 1px solid rgba(148, 163, 184, 0.22) !important;
  border-radius: 0 0 18px 18px;
  background: rgba(255, 255, 255, 0.98);
}

.editor-shell--description .ql-editor {
  min-height: 150px;
  border-radius: 0 0 18px 18px;
}
</style>
<style scoped>
.tickets-toolbar {
  margin-bottom: 18px;
  padding: 18px 20px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 22px;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(16px);
}

.tickets-toolbar__search {
  margin-top: 8px;
}

.ticket-toolbar__btn {
  min-width: 178px;
}

.ticket-card {
  width: 100%;
  margin-bottom: 15px;
  padding: 10px 0;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-left: 5px solid var(--ticket-accent);
  border-radius: 18px !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.94) 100%) !important;
  box-shadow: 0 12px 22px rgba(15, 23, 42, 0.06);
}

.ticket-card__row {
  min-height: 96px;
}

.ticket-card__main,
.ticket-card__side,
.ticket-card__menu-col {
  padding-inline: 8px !important;
}

.ticket-card__side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.ticket-card__meta {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--ticket-accent-strong);
}

.ticket-card__client {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
  color: #475569;
  font-size: 0.92rem;
}

.ticket-card__separator {
  color: var(--ticket-accent-strong);
  font-size: 0;
}

.ticket-card__separator::before {
  content: "|";
  font-size: 0.82rem;
}

.ticket-card__subject {
  color: #1e293b;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
}

.ticket-card__tags {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.ticket-card__info-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ticket-card__info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #334155;
  font-size: 0.92rem;
}

.ticket-card__info-item .v-icon {
  color: var(--ticket-accent-strong);
}

.ticket-card__action {
  min-height: 34px !important;
  margin-top: 10px;
  padding-inline: 12px !important;
  border-radius: 12px !important;
  background: var(--ticket-accent-soft) !important;
  color: var(--ticket-accent-strong) !important;
  box-shadow: none !important;
}

.ticket-card__action .v-icon {
  color: inherit !important;
}

.ticket-card__menu {
  background: rgba(148, 163, 184, 0.14);
}

.ticket-tag {
  border: 1px solid rgba(148, 163, 184, 0.18) !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.92) !important;
  color: #334155 !important;
  font-weight: 600;
}

.ticket-tag--kanban {
  background: var(--ticket-accent-soft, rgba(15, 118, 110, 0.12)) !important;
  color: var(--ticket-accent-strong, #0f766e) !important;
  border-color: transparent !important;
}

.ticket-tag__dot {
  display: inline-flex;
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 999px;
  background: var(--ticket-accent-strong, #0f766e);
}

.ticket-actions-list {
  min-width: 220px;
}

.return-thread {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 10px;
}

.return-thread__day {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.return-thread__bubble {
  width: 100%;
  max-width: 100%;
  padding: 16px 18px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 22px;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.return-thread__bubble--initial {
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.96) 100%);
}

.return-thread__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  align-items: center;
  margin-bottom: 8px;
}

.return-thread__meta strong {
  color: #0f172a;
  font-size: 0.95rem;
}

.return-thread__meta span {
  color: #0f766e;
  font-size: 0.8rem;
  font-weight: 700;
}

.return-thread__subject {
  margin-bottom: 10px;
  color: #334155;
  font-size: 0.9rem;
  font-weight: 700;
}

.return-thread__content {
  color: #334155;
  line-height: 1.7;
}

.return-thread__content p:last-child {
  margin-bottom: 0;
}

.return-thread__footer {
  display: flex;
  justify-content: flex-start;
  padding-top: 8px;
}

.kanban-ticket {
  gap: 10px;
  padding: 14px !important;
  border-left-width: 4px !important;
  border-radius: 16px !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.96) 100%) !important;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06) !important;
}

.kanban-ticket__drag {
  cursor: grab;
}

.kanban-ticket__drag:active {
  cursor: grabbing;
}

.kanban-ticket__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.kanban-ticket__avatars {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kanban-ticket__menu {
  width: 30px !important;
  height: 30px !important;
  background: rgba(148, 163, 184, 0.12);
  color: #475569 !important;
}

.kanban-ticket__body {
  cursor: pointer;
}

.kanban-ticket__date {
  color: #475569;
  font-size: 0.82rem;
}

.kanban-ticket__title {
  margin-top: 8px;
  color: #1e293b;
  font-size: 1.02rem;
  font-weight: 700;
  line-height: 1.35;
}

.kanban-ticket__client {
  margin-top: 6px;
  color: #64748b;
  font-size: 0.88rem;
  line-height: 1.45;
}

.kanban-ticket__tags {
  display: flex;
  flex-wrap: wrap;
}

.kanban {
  display: flex;
  justify-content: stretch;
  width: 100%;
  height: 100%;
  user-select: none;
}

.kanban__move-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-size: 0.9rem;
  color: #b0b0b0;
  user-select: none;
}

.kanban__move-icon span {
  margin-left: 10px;
}

.kanban__move-icon svg {
  width: 20px;
  height: 20px;
}

.kanban__drop-preview {
  position: relative;
  margin: 10px;
  background-color: #edf1f3;
  border: 2px dashed rgba(0, 0, 0, 0.059);
  border-radius: 4px;
}

.kanban__drop-preview::before {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #b0b0b0;
  transform: translate(-50%, -50%);
}

.kanban__drop-preview::after {
  position: absolute;
  top: 50%;
  left: 27%;
  width: 20px;
  height: 20px;
  content: "";
  transform: translate(-50%, -50%);
}

.kanban__description {
  display: flex;
  align-items: center;
}

.kanban__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #edf5f7;
  padding: 0.5rem;
  border-radius: 8px;
}

.kanban__title {
  margin: 0 0 0 5px;
  font-size: 1rem;
  font-weight: bold;
  color: #555;
}

.kanban__quantity {
  margin-top: 0;
  font-size: small;
  color: #b0b0b0;
  text-align: right;
}

.kanban__quantity--inner-count {
  margin: 1rem 1rem 0 1rem;
  padding-top: 0.5rem;
}

.kanban__column {
  flex: 1;
  height: fit-content;
  padding: 10px;
  border-radius: 18px;
  transition: height 0.5s ease;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.05);
}

.kanban__column:not(:first-of-type) {
  margin-left: 15px;
}

.kanban__column--no-border {
  border: none;
}

.kanban__header {
  margin-bottom: 15px;
  background-color: transparent;
}

.kanban__content {
  position: relative;
}

.kanban__skeleton {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 15px;
  padding-right: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
  overflow: auto;
}

.kanban__skeleton-container {
  width: 100%;
}

.kanban__skeleton-column {
  flex: 1;
  height: calc(100% - 30px);
  padding: 10px;
  margin-left: 15px;
  background-color: #e9e9e9;
  border-radius: 6px;
}

.kanban__skeleton-card {
  position: relative;
  height: 100px;
  padding: 15px;
  margin-top: 16px;
  background-color: #f5f5f5;
  border-radius: 6px;
}

.kanban__skeleton-card--one {
  position: absolute;
  top: 8px;
}

.kanban__skeleton-card--two {
  position: absolute;
  top: 8px;
  right: 10px;
}

.kanban__skeleton-card--three {
  position: absolute;
  top: 30px;
}

.kanban__skeleton-card--four {
  position: absolute;
  bottom: 2rem;
}

.kanban__skeleton-card--five {
  position: absolute;
  left: 1rem;
  bottom: 0.5rem;
}

.item,
.draggable-item,
.draggable-item-horizontal {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 8px;
  cursor: pointer;
  user-select: none;
  background-color: rgba(255, 255, 255, 0.96);
  border: 1px solid transparent;
  border-left: 5px solid #e0e0e0;
  border-radius: 18px;
  transition: border-color 0.2s linear;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06);
}

.item-ghost {
  margin: 0 !important;
  transform: none !important;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.14);
}

.kanban__drag-ghost {
  margin: 0 !important;
  transform: none !important;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18) !important;
}

.kanban__drop-ghost {
  margin: 0 !important;
  transform: none !important;
}

.item .card {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item .card small {
  color: #838383;
}

.item.open {
  border-left: 5px solid #f3c1c1;
}

.item.executing {
  border-left: 5px solid #c4ebaf;
}

.item.finished {
  border-left: 5px solid #b3d5e9;
}

.item.paralised {
  border-left: 5px solid #dc3545;
}

.item.testando {
  border-left: 5px solid #a4f312;
}

.item.review {
  border-left: 5px solid #e0e0e0;
}

.badge {
  margin: 1rem 0;
  cursor: pointer;
}

.label {
  color: #1e293b;
  margin-bottom: 5px;
  font-weight: 700;
}

.kanban-action {
  display: flex;
  justify-content: space-between;
}

.kanban-button {
  max-width: 130px;
  pointer-events: none;
  border: none;
  color: #f7f7f7;
  padding: 1px 20px;
  text-align: center;
  text-decoration: none;
  border-radius: 100px;
}

.kanban-button.open {
  background-color: #f3c1c1;
}

.kanban-button.executing {
  background-color: #c4ebaf;
}

.kanban-button.finished {
  background-color: #b3d5e9;
}

.kanban-button.testando {
  background-color: #a4f312;
}

.kanban-button.review {
  background-color: #e0e0e0;
}

.kanban-cards {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5px 0;
}

@media (max-width: 991px) {
  .tickets-toolbar__search {
    margin-top: 12px;
  }

  .ticket-toolbar__btn {
    width: 100%;
  }

  .ticket-card__row {
    row-gap: 10px;
  }

  .ticket-card__main,
  .ticket-card__side,
  .ticket-card__menu-col {
    padding-inline: 12px !important;
  }
}
</style>
